mtl.alloy.factory['toggle-addressBook'] = (function($) {
    'use strict';

    return function(element, options) {

        var $checkoutForm = $(element);

        var $addressInputs = $checkoutForm.find('.radioOptions').find('input');
        var $selectedInput = $checkoutForm.find('.radioOptions').find('input:checked');

        $addressInputs.click(function() {

            var inputName = $(this).attr('id');
            var inputLabel = $('label[for="' + inputName + '"]').text();

            if(inputLabel === 'Add New Address') {
                $checkoutForm.find('.new-address').show();
            }

            if(inputLabel !== 'Add New Address') {
                $checkoutForm.find('.new-address').hide();
            }

        });

        $selectedInput.trigger('click');

    };

}(jQuery));
